import { FC, useEffect, useState } from "react";
import Errors from "../../../components/errors/Errors";
import Listview from "../../../components/listview/Listview";
import { DefaultPagination, getPagination, Pagination } from "../../../components/listview/Pagination";
import useAbortController from "../../../hooks/useAbortController";
import { Members } from "../../../listsSettings/members";
import { ErrorCode, IListviewField, SearchResult, UserPermissions } from "../../../services/types";
import { getUserPermissions } from "../../../services/webapi";
import * as Fields from "./Fields";
import { LegalRepresentative } from "./types";
import { getLegalRepresentativeFilters, getLegalRepresentatives } from "./webapi";

const AllItems: FC = () => {
  const [abortController, resetAbortController] = useAbortController();
  const listviewId = "legal-representatives-all-items";
  const fields: IListviewField<LegalRepresentative>[] = [
    Fields.firstName,
    Fields.lastName,
    Fields.taxCode,
    Fields.zip,
    Fields.city,
    Fields.province,
    Fields.phone,
    Fields.mobile,
    Fields.email,
    Fields.member,
  ];

  const [chapters, setLegalRepresentatives] = useState<SearchResult<LegalRepresentative> | null>(null);
  const [errorCode, setErrorCode] = useState<ErrorCode>();
  const [permissions, setPermissions] = useState<UserPermissions>();

  const pagination = getPagination(listviewId) || {
    ...DefaultPagination,
  };

  useEffect(() => {
    loadLegalRepresentatives(pagination);

    return () => {
      abortController && abortController.abort();
    };
  }, []);

  const loadLegalRepresentatives = async (pagination: Pagination) => {
    const abortController = resetAbortController();
    const permissions = await getUserPermissions(
      Members.Lists.LegalRepresentatives.InternalName,
      Members.InternalName,
      abortController.signal,
    );

    if (!abortController.signal.aborted) {
      setPermissions(permissions);
      const canRead = permissions.schemaPermission && permissions.listPermissions.includes("read-all");
      !canRead && setErrorCode(403);
      if (canRead) {
        const result = await getLegalRepresentatives(pagination, abortController.signal);
        if (!abortController.signal.aborted) {
          result.data && setLegalRepresentatives(result.data);
          result.error && setErrorCode(result.error.code);
        }
      }
    }
  };

  return (
    <>
      {permissions &&
        (!errorCode ? (
          <Listview
            id={listviewId}
            viewProperties={{
              schema: Members.InternalName,
              list: Members.Lists.LegalRepresentatives.InternalName,
              name: "all_items",
              setListAndPage: true,
            }}
            fields={fields}
            reload={loadLegalRepresentatives}
            searchResult={chapters}
            getFilters={getLegalRepresentativeFilters}
            pagination={pagination}
            updateItems={(items) =>
              chapters &&
              setLegalRepresentatives({
                ...chapters,
                items: items,
              })
            }
          />
        ) : (
          errorCode && <Errors errorCode={errorCode} />
        ))}
    </>
  );
};

export default AllItems;
